export const pluginPrefix = 'PLUGIN:CUSTOMER_DISPLAY:';

export const SET_HAS_PERMISSION = `${pluginPrefix} SET_HAS_PERMISSION`;
export const SET_FETCHED_INITIAL_SCREEN_DETAILS = `${pluginPrefix} SET_FETCHED_INITIAL_SCREEN_DETAILS`;
export const SET_SCREENS = `${pluginPrefix} SET_SCREENS`;
export const SET_SELECTED_SCREEN = `${pluginPrefix} SET_SELECTED_SCREEN`;
